import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import doctors from './doctors'
import patients from './patients'
import insurance from './insurance'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    activeIndex: localStorage.getItem('activeIndex') || 1,
    token: localStorage.getItem('token') || null,
    prefectures: JSON.parse(localStorage.getItem('prefectures')) || null,
    municipalities: JSON.parse(localStorage.getItem('municipalities')) || null,
    sideNav: true,
    loading: false,
  },
  getters: {
    isAuth: state => !!state.token
  },
  mutations: {

    getPrefectures(state, prefectures) {
      prefectures.unshift({option_key: null, option_value: 'All'})
      localStorage.setItem('prefectures', JSON.stringify(prefectures))
      state.prefectures = prefectures
      //console.log(typeof(countries))
    },
    getMunicipalities(state, municipalities){
      municipalities.unshift({option_key: null, option_value: 'All'})
      localStorage.setItem('municipalities', JSON.stringify(municipalities))
      state.municipalities = municipalities
    },
    login(state, res) {
      localStorage.setItem('token', res.data.token)
      state.token = res.data.token
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`
    },
    logout(state) {
      localStorage.removeItem('token')
      localStorage.removeItem('countries')
      localStorage.removeItem('activeIndex')
      localStorage.removeItem('doctors')
      delete axios.defaults.headers.common['Authorization']
      state.token = null
    },
    setLoading(state, value) {
      state.loading = value
    },
    setActiveIndex(state, index) {
      localStorage.setItem('activeIndex', index)
      state.activeIndex = index
    },
    sideNav(state) {
      state.sideNav = !state.sideNav
    },
    sideNavTrue(state) {
      state.sideNav = true;
    }
  },
  actions: {
    getPrefectures({ commit }) {
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/optionsList/greekPrefectures/el`)
        .then(res => {
          commit('getPrefectures', res.data)
          return axios
            .get(
              `${process.env.VUE_APP_BASE_URL}/optionsList/greekMunicipalities/el`
            )

        })
        .then(res => {
          commit('getMunicipalities', res.data)
        })
        .catch(err => {
          console.log(err);
        });
    },
    login({ commit }, credentials) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        axios.post(`${process.env.VUE_APP_BASE_URL}user/login`, credentials)
          .then(res => {
            commit('login', res)
            commit('setLoading', false)
            commit('sideNavTrue')

            //console.log('login', res.data.)
            resolve(res)
          })
          .catch(err => {
            commit('setLoading', false)
            reject(err)
          })
      })
    },
    logout({ commit }) {
      commit('logout')
      commit('sideNav')
    },
    setActiveIndex({ commit }, index) {
      commit('setActiveIndex', index)
    },
    sideNav({ commit }) {
      commit('sideNav')
    }
  },
  modules: {
    doctors,
    patients,
    insurance
  }
})
